// extracted by mini-css-extract-plugin
module.exports = {"container":"comingSoon_container__NWMe7","btndiv":"comingSoon_btndiv__2d2N5","cancelbtn":"comingSoon_cancelbtn__3WuqS"};